import React from 'react';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { SignupForm } from '@/components/auth/SignupForm';

/**
 * Signup page wrapper component
 * Combines AuthLayout with SignupForm
 */
const SignupPage: React.FC = () => {
  return (
    <AuthLayout
      title="Create Account"
      subtitle="Join thousands of restaurants using Digital Menu"
    >
      <SignupForm />
    </AuthLayout>
  );
};

export default SignupPage;